import { render, staticRenderFns } from "./permanen.vue?vue&type=template&id=0cdd7fda&scoped=true"
import script from "./permanen.vue?vue&type=script&lang=js"
export * from "./permanen.vue?vue&type=script&lang=js"
import style0 from "./permanen.vue?vue&type=style&index=0&id=0cdd7fda&prod&lang=scss"
import style1 from "./permanen.vue?vue&type=style&index=1&id=0cdd7fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdd7fda",
  null
  
)

export default component.exports